






import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

@Component({
})
export default class AppLoader extends Vue {
  @Prop() readonly value!: boolean

  windowSize = {
    w: 0,
    h: 0
  }

  mounted () {
    this.onResize()
  }
  onResize () {
    this.windowSize = { w: window.innerWidth, h: window.innerHeight }
  }
}
